import { render } from "./Total.vue?vue&type=template&id=3b292c49&lang=pug"
import script from "./Total.vue?vue&type=script&setup=true&lang=js"
export * from "./Total.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__